import { render, staticRenderFns } from "./OrderProductDetails.vue?vue&type=template&id=4882eee2&scoped=true"
import script from "./OrderProductDetails.vue?vue&type=script&lang=js"
export * from "./OrderProductDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderProductDetails.vue?vue&type=style&index=0&id=4882eee2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4882eee2",
  null
  
)

export default component.exports